import Nullstack from 'nullstack';
export default function IconLogicNand({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-logic-nand",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-3"
  }), "   ", Nullstack.element("path", {
    d: "M2 9h3"
  }), "   ", Nullstack.element("path", {
    d: "M2 15h3"
  }), "   ", Nullstack.element("path", {
    d: "M7 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "12",
    r: "2"
  }), " ");
}